import { render } from "./CallCenterServiceCaptureDashboard.vue?vue&type=template&id=61fe17d1&scoped=true"
import script from "./CallCenterServiceCaptureDashboard.vue?vue&type=script&lang=js"
export * from "./CallCenterServiceCaptureDashboard.vue?vue&type=script&lang=js"

import "./CallCenterServiceCaptureDashboard.vue?vue&type=style&index=0&id=61fe17d1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61fe17d1"]])

export default __exports__